// extracted by mini-css-extract-plugin
module.exports = {"poweredBy":"PoweredBy_poweredBy__2g-Cn","poweredBy__img":"PoweredBy_poweredBy__img__27sY5"};